import React from 'react';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';

export function DateRangePickerControl({ settings, name, onChange, onBlur, ...props }) {
  return (
    <DatePicker.RangePicker
      style={{ width: '100%' }}
      allowClear={false}
      name={name}
      onChange={range => onChange({ target: { name, value: range } })}
      onBlur={() => onBlur({ target: { name } })}
      {...settings}
      {...props}
    />
  );
}

DateRangePickerControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
